import styled from 'styled-components';

type ContainerProps = {
  left: number;
  zIndex: number;
};

export const Container = styled.div<ContainerProps>`
  overflow: hidden;
  position: absolute;
  min-width: 8rem;
  max-width: 10rem;
  max-height: 5rem;
  min-height: 4.5rem;
  box-shadow: 0px 3px 6px #00000029;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.error_200};
  .event-schedule {
    header {
      display: flex;
      align-items: center;
      img {
        width: 1.5rem;
      }
    }

    p {
      margin-top: 0.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* number of lines to show */
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    a,
    p {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.secondary};
      margin-top: 0.25rem;
    }
    a {
      font-weight: 500;
    }
  }

  left: ${({ left }) => left}px;
  transition: all linear 200ms;
  z-index: ${({ zIndex }) => zIndex};

  &:hover {
    z-index: ${({ zIndex }) => zIndex + 1};
  }

  top: 0;
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  #divContainerEvents {
    display: flex;
    justify-content: space-between;
    .Title {
      font-weight: 450;
    }
    button {
      border: 0;
      margin: 0;
      background-color: transparent;
      transition: all ease-out 200ms;
      padding: 4px;
    }

    button:hover {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 50%;
    }

    img {
      width: 20px;
    }
  }
  .btn-view-solicitation {
    width: 100%;
    height: 25px;
    background-color: ${({ theme }) => theme.colors.background_white};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.primary};
    font-family: 'Futura PT';
    font-weight: 450;
    margin-top: 8px;
    cursor: pointer;
    transition: all linear 200ms;
  }
  .btn-view-solicitation:hover {
    filter: brightness(0.9);
  }
`;

export const Title = styled.p`
  font-weight: 450;
`;

export const Description = styled.p`
  font-weight: 300;
  padding-top: 0.5rem;
`;

export const ContainerMakingNoteEvent = styled.td`
  width: 10rem;
  height: 88px;
  padding: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.background_white};
  top: 0;
  #ButtonAddAnotation {
    width: 90%;
    height: 90%;
    outline: 0;
    border: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: none;
  }
  #TextMakingNote {
    display: flex;
    flex-direction: column !important;
    padding: 0.2rem;
    min-width: 6.9rem;
    max-height: 4rem;
    max-width: 7rem;
    min-height: 4rem;
    justify-content: center;
    align-items: center;
    outline: 0;
    resize: none;
    border: 0 !important;
    margin: 0 !important;
    background-color: ${({ theme }) => theme.colors.background_white};
  }
  #divButtons {
    width: 90%;
    border: 0 !important;
    margin-top: -0.7rem;
    padding: 0 !important;
    #buttonDemanda {
      background-color: transparent !important;
      outline: 0;
      border: 0;
      width: 40%;
      &:nth-child(1) {
        margin-right: 0.1rem;
      }
      color: ${({ theme }) => theme.colors.tertiary_500};
      text-decoration: underline;
      font-size: 0.6rem;
      #buttonDemanda:hover {
        border-radius: 0 !important;
      }
    }
  }
`;
